import FullscreenAd from '../../../../../pages/vip/features/fullscreen-ad/index';

export default FullscreenAd;
